module.exports = "#participantes th{\n  text-transform: uppercase;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/lista-participantes/participantes.css
// module id = ./src/app/lista-participantes/participantes.css
// module chunks = main